import React, { useEffect, useRef, useState } from "react";
import {Toast} from 'antd-mobile'
import styled from "styled-components";
import CheckImg from './imgs/check@2x.png';
import Header from "@/components/Header";
import styles from '@/styles';
import EmptyList from './imgs/empty-list@2x.png';
import CheckNotImg from './imgs/check-not@2x.png';
import moment from 'moment';
import ListView from '@/components/ListView/list-view'
import { getMyInvite } from './api';
import { invite_bg, invite_text, invite_card_bg } from '@/styles/theme'

const MyInvitation = () => {
  const [data, setData] = useState([]);
  const dataRef = useRef([]);
  dataRef.current = data;
  
  const loadAllRef = useRef(false);
  const pageRef = useRef(1);

  useEffect(() => {
    getData().then(res => {
      setData(res)
    })
  }, [])

  const getData = () => {
    return new Promise((resolve, reject) => {
      getMyInvite({ pageNo: pageRef.current, pageSize: 10 }).then(res => {
        if (pageRef.current * 10 >= res.totalCount) {
          loadAllRef.current = true
        }
        resolve(res.userList);
      })
    })
  }

  const formatDate = (date) => {
    if (!date) {
      return '';
    }
    return moment(date).format('YYYY-MM-DD')
  }

  const handleReachBottom = () => {
    if (loadAllRef.current) {
      return;
    }
    Toast.loading();
    pageRef.current = pageRef.current + 1;
    getData().then((res) => {
      setData([...dataRef.current, ...res]);
      Toast.hide();
    }).catch(() => {
      Toast.hide();
    })
  }

  return (
    <Container>
      <Header
        title="我的邀请"
        hideNaviBar
        bg_color={styles.bg_color2}
        className="page-header"
      />
      <div className="invite-list">
        { data.length === 0 ? 
          <div className="empty-list-wrap">
            <img src={EmptyList} alt="" className="empty-list-img"/>
            <div className="empty-text">
              <div>您暂未邀请好友</div>
              <div>快去邀请好友领现金红包吧</div>
            </div>
          </div>
          :
          <ListView onReachBottom={handleReachBottom}>
            {data.map(item => {
            return (
              <div key={item.userId} className="invite-item">
                <div className="friend-info">
                  <div className="info-box">
                    <div className="friend-avatar">
                      <img className="avatar-img" alt="" src={item.avatar} />
                    </div>
                    <div className="friend-name">{item.userName}</div>
                  </div>
                  <div className="friend-type">{item.isNewUser === 1 ? '新用户' : '老用户'}</div>
                </div>
                {item.taskList.map((task, index) => (
                  <div key={index} className="finish-item">
                    <div className="finish-label">
                      <img src={task.status === 1 ? CheckImg : CheckNotImg} className="finish-check" alt=""/>
                      <span className="finish-text">{task.taskName}</span>
                    </div>
                    <div className="finish-date">{task.status === 1 ? `${formatDate(task.finishTime)}完成` : `未完成`}</div>
                  </div>
                ))}
              </div>
            )
          })}
          </ListView>
          
        }
      </div>
    </Container>
  )
}

export default MyInvitation;

const Container = styled.div`
  .invite-list {
    width: 100%;
    background: ${invite_bg};
    padding: 27px 18px;
    box-sizing: border-box;
    min-height: calc(100vh - 44px);
  }
  .empty-list-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 190px;
    .empty-list-img {
      width: 79px;
      height: 86px;
      margin-bottom: 16px;
    }
    .empty-text {
      font-size: 14px;
      font-weight: 400;
      color: ${invite_text};
      line-height: 21px;
      letter-spacing: 3px;
      text-align: center;
    }
  }
  .invite-item {
    &:first-child {
      margin-top: 0;
    }
    margin-top: 26px;
    background: ${invite_card_bg};
    box-shadow: 0px 7px 8px 0px rgba(45,45,45,0.21);
    border-radius: 10px;
    padding: 17px 19px 39px;
    color: ${invite_text};
  }
  .friend-info, .finish-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .friend-info {
    margin-bottom: 39px;
    font-size: 15px;
    font-weight: 500;
    color: ${invite_text};
  }
  .info-box {
    display: flex;
    align-items: center;
    .friend-avatar {
      width: 26px;
      height: 26px;
      border-radius: 13px;
      .avatar-img {
        width: 26px;
        height: 26px;
        border-radius: 13px;
      }
    }
    .friend-name {
      margin-left: 9px;
    }
  }
  .finish-item {
    font-size: 12px;
    font-weight: 400;
    color: ${invite_text};
    line-height: 12px;
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0;
    }
    .finish-check {
      width: 11px;
      height: 11px;
      
    }
    .finish-text {
      margin-left: 4px;
      line-height: 12px;
      font-size: 12px;
    }
    .finish-label {
      display: flex;
      font-size: 0;
    }
    .finish-date {
      flex-shrink: 0;
      margin-left: 8px;
    } 
  }
  .page-header {
    height: 44px;
  }
  .share-img {
    width: 20px;
    width: 20px;
    vertical-align: middle;
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_42/my-invite.js